import { useAppSelector } from "@/shared/lib/redux"
import { selectUser, selectUserCardLoading, selectUserHasCard } from "../../model"
import { format, parseISO } from "date-fns"

const genders = {
    'male': 'Мужской',
    'female': 'Женский'
}

export const UserInfoGrid = () => {
    const user = useAppSelector(selectUser)
    const hasCard = useAppSelector(selectUserHasCard)
    const cardLoading = useAppSelector(selectUserCardLoading)
    
    return (
        <div className="grid grid-cols-12 gap-x-3 p-4">
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    ФИО
                </div>
                <div className="text-[13px] font-semibold">
                    {user.name ? user.name : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    username
                </div>
                <div className="text-[13px] font-semibold">
                    {user.username ? '@' + user.username : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    ПОЛ
                </div>
                <div className="text-[13px] font-semibold">
                    {user.gender ? genders[user.gender] : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Дата регистрации
                </div>
                <div className="text-[13px] font-semibold">
                    {user.date_of_registration ? format(user.date_of_registration, 'dd.MM.yyyy') : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Телефон
                </div>
                <div className="text-[13px] font-semibold">
                    {user.phone ? user.phone : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Почта
                </div>
                <div className="text-[13px] font-semibold">
                    {user.email ? user.email : '—'}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Роль
                </div>
                <div className="text-[13px] font-semibold">
                    {user.role.name}
                </div>
            </div>
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Группа
                </div>
                <div className="text-[13px] font-semibold">
                    {user.group ? user.group.name : '—'}
                </div>
            </div>
            <div className="col-span-12 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Дата рождения
                </div>
                <div className="text-[13px] font-semibold">
                    {user.date_of_birth ? format(user.date_of_birth, 'dd.MM.yyyy') : '—'}
                </div>
            </div>
            <div className="col-span-12 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    Привязана карта
                </div>
                <div className="text-[13px] font-semibold">
                    {cardLoading ? 'Загрузка...' : hasCard ? 'Да' : 'Нет'}
                </div>
            </div>
            {user.is_deleted && (
                <>
                    <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                        <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                            Удалён
                        </div>
                        <div className="text-[13px] font-semibold">
                            {user.is_deleted ? 'Да' : 'Нет'}
                        </div>
                    </div>
                    <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                        <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                            Дата удаления
                        </div>
                        <div className="text-[13px] font-semibold">
                            {user.deleted_at ? format(parseISO(user.deleted_at), 'dd.MM.yyyy HH:mm') : '—'}
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}